import React from 'react'

import { useLightMode } from '@/hooks/useLightMode'

import { Box, Tooltip } from '@chakra-ui/react'

import { DarkProvider, UtilityButton } from '@hivewatch/dark'

interface IncidentActionTabIProps {
  icon: React.ReactElement<{ color?: string; size?: number }>
  label: string
  onClick: () => void
  isSelected: boolean
  disabled?: boolean
  // Optional tooltip text shown in place of `label` — e.g. to explain why the
  // button is disabled. When provided, the tooltip remains visible even while
  // the button is disabled.
  tooltipLabel?: string
}

export const IncidentActionTab = ({
  disabled = false,
  icon,
  isSelected,
  label,
  onClick,
  tooltipLabel,
}: IncidentActionTabIProps) => {
  const colorScheme = useLightMode()
  return (
    <Tooltip
      bg='#1b253f'
      color='white'
      hasArrow
      isDisabled={isSelected || (disabled && !tooltipLabel)}
      label={tooltipLabel ?? label}
      mt='5px'
      openDelay={250}
      p='10px'
    >
      <Box as='span' display='inline-block'>
        <DarkProvider>
          <UtilityButton
            colorScheme={colorScheme}
            disabled={disabled}
            icon={icon}
            isSelected={isSelected}
            label={label}
            onClick={onClick}
          />
        </DarkProvider>
      </Box>
    </Tooltip>
  )
}
